
import { Component } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import WizardContentView
  from '@/ui/components/wizards/baseComponents/WizardContentView.vue';
import { IProject } from '@/types/project.types';
import WizardComponent from '@/ui/components/wizards/baseComponents/WizardComponent';
import {
  newChargeStationLimitDate,
  plcVersionDate,
} from '@/utils/versionManagementUtils';
import { IInverter } from '@/types/serialNumber.types';
import LynusPopup from '@/ui/components/components/LynusPopup.vue';

@Component({
  components: {
    LynusPopup,
    WizardContentView,
  },
})
export default class Information extends WizardComponent {
  @Getter('mqttClient/isProjectOnline') isProjectOnline!: boolean;
  @Getter('installationWizard/considerProjectStatus') considerProjectStatus !: boolean;
  @Getter('projects/project') project!: IProject;
  @Getter('serialNumber/inverters') inverters!: IInverter[];
  @Getter('projects/isDeye') isDeye!: boolean;
  @Getter('projects/isSolarmax') isSolarmax!: boolean;
  @Getter('projects/isMobileDeye') isMobileDeye!: boolean;
  @Getter('installationWizard/emsLimits') emsLimits!: Record<string, number>;
  @Mutation('installationWizard/setDisablePilotDevices') setDisablePilotDevices!: (value: boolean) => void;
  @Mutation('installationWizard/setSerialNumberCheckDone') setSerialNumberCheckDone!: () => void;
  @Action('installationWizard/initDevices') initDevices!: () => void;

  showAdditionalMessage = false;
  showPopup = false;
  localStorageKey = 'lynusNewWizardPopup';

  async created() {
    await this.fetchMeasurements(this.$route.params.id);
    if (this.measurements['prgEM.bEnable'] && this.measurements['prgEM.bEnable'] === 1) {
      this.showAdditionalMessage = true;
      this.setDisablePilotDevices(true);
    }
  }
  handleClose() {
    this.showPopup = false;
  }
  mounted() {
    const lastShown = localStorage.getItem(this.localStorageKey);
    const oneWeek = 7 * 24 * 60 * 60 * 1000; // One week in milliseconds
    const now = new Date().getTime();

    // Check if the popup was never shown or if a week has passed since last shown
    if (!lastShown || now - parseInt(lastShown, 10) > 1) {
      setTimeout(() => {
        // this.showPopup = true;
        // Update localStorage with the current timestamp
        localStorage.setItem(this.localStorageKey, now.toString());
      }, 1000);
    }
  }

  openNewWizard() {
    window.open(`https://app.lynus.io/${this.project.id}/wizard`, '_blank');
  }

  get isNewChargeStationPlcVersion() {
    return (plcVersionDate(this.project).getTime() > newChargeStationLimitDate.getTime()) && (this.isDeye || this.isSolarmax);
  }

  handleStart() {
    // initialise EnergyView and EMS device object in store
    this.initDevices();
    this.handleIncrement();
  }
}
